import { render, staticRenderFns } from "./CompanyProfile2.vue?vue&type=template&id=550d69f0&scoped=true&"
import script from "./CompanyProfile2.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile2.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile2.vue?vue&type=style&index=0&id=550d69f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d69f0",
  null
  
)

export default component.exports